// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2MoWr","topBottomGutter":"Layout_topBottomGutter__3RS84"};